

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const ALUMNIREGISTRATIONREJECT= createAsyncThunk(
  "AlumniRegistrationReject/AlumniRegistrationReject",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const AlumniRegistrationRejectSlice = createSlice({
  name: "AlumniRegistrationRejectSlice",
  initialState: {
    AlumniRegistrationReject: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfAlumniRegistrationReject: (state) => {
        state.AlumniRegistrationReject.loading = false
        state.AlumniRegistrationReject.error = false
        state.AlumniRegistrationReject.data = []
        state.AlumniRegistrationReject.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ALUMNIREGISTRATIONREJECT.fulfilled, (state, action) => {
      state.AlumniRegistrationReject = {
        ...state.AlumniRegistrationReject,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIREGISTRATIONREJECT.pending, (state, action) => {
      state.AlumniRegistrationReject = {
        ...state.AlumniRegistrationReject,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIREGISTRATIONREJECT.rejected, (state, action) => {
      state.AlumniRegistrationReject = {
        ...state.AlumniRegistrationReject,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const AlumniRegistrationRejectAction = {
    ALUMNIREGISTRATIONREJECT,
};

export { AlumniRegistrationRejectAction };
export default AlumniRegistrationRejectSlice.reducer;
export const {setInitialStateOfAlumniRegistrationReject} = AlumniRegistrationRejectSlice.actions
